import * as types from './index';

export const fcmNotifiTokenSaveAction = (data) =>{
    return {
        type: types.FCM_NOTIFI_TOKEN_SAVE, 
        data
    }
}

export const fcmNotificationSendAction = (data) =>{
    return {
        type: types.FCM_NOTIFICATION_SEND,
        data
    }
}

export const notificationsFetchAction = (data) =>{
    return {
        type: types.NOTIFICATIONS_FETCH, 
        data
    }
}

export const notificationReadAction = (data) =>{
    return {
        type: types.NOTIFICATION_READ, 
        data
    }
}

export const notificationsFetchDropDownAction = (data) =>{
    return {
        type: types.NOTIFICATIONS_FETCH_DROPDOWN, 
        data
    }
}

export const notificationsAllMarkAsReadAction = (data) =>{
    return {
        type: types.NOTIFICATIONS_ALL_MARK_AS_READ, 
        data
    }
}





